/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';
    /**
     * A directive that handles receipt form fields for a Receipt object.
     */
    angular
        .module('enervee.fastTrack')
        .directive('fastTrackReceiptUploader', FastTrackReceiptUploaderDirective);


    FastTrackReceiptUploaderDirective.$inject = [];
    function FastTrackReceiptUploaderDirective() {
        return {
            restrict: 'E',
            scope: {
                isLocked: '=',
                receipt: '=',
                fieldPostFix: '@?',
                errors: '=',
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: FastTrackReceiptUploaderController,
            template: require('@app/components/fastTrack/uploadReceiptsModal/fastTrackReceiptUploader/fastTrackReceiptUploaderView.html'),
        };
    }

    FastTrackReceiptUploaderController.$inject = ['$timeout'];
    function FastTrackReceiptUploaderController($timeout) {
        var vm = this;
        var ignoreNextDateFocus = false;
        var dateFocusIgnoreTimeout = null;
        vm.removeReceipt = removeReceipt;
        vm.onDateFocus = onDateFocus;
        vm.openDatepicker = openDatepicker;
        vm.toggleDatepicker = toggleDatepicker;
        vm.datepickerIsOpen = false;
        vm.datepickerOptions = {
            maxDate: new Date(),
            maxMode: 'day',
            showWeeks: false,
        };

        /**
         * Remove the given receipt from the array.
         *
         * @param {number} index
         */
        function removeReceipt(index) {
            vm.receipt.images.splice(index, 1);
        }

        /**
         * Handler for when the date input is focused. Selecting a date from the datepicker seems
         * to focus the date input twice, so if a focus event is triggered when the datepicker is
         * already open, it is assumed to be from the datepicker calendar itself, and the next
         * focus event within 150ms is ignored.
         */
        function onDateFocus() {
            if (vm.datepickerIsOpen) {
                ignoreNextDateFocus = true;
                if (dateFocusIgnoreTimeout) {
                    $timeout.cancel(dateFocusIgnoreTimeout);
                }
                dateFocusIgnoreTimeout = $timeout(function () {
                    ignoreNextDateFocus = false;
                }, 150);
                return;
            }

            // If we're _not_ ignore that the input was focused, open the datepicker.
            if (!ignoreNextDateFocus) {
                vm.openDatepicker();
            }

            // Reset whether or not the next focus event should be ignored.
            ignoreNextDateFocus = false;
        }

        /**
         * Opens the receipt datepicker.
         */
        function openDatepicker() {
            vm.datepickerIsOpen = true;
        }

        /**
         * Toggles whether or not the receipt datepicker is open.
         */
        function toggleDatepicker() {
            vm.datepickerIsOpen = !vm.datepickerIsOpen;
        }
    }
})(angular);
